export enum QuizEvent {
  SET_PLUGIN_DATA = "set_plugin_data",
  SET_QUIZ_DATA = "set_quiz_data",
  CLOSE_WITH_ERROR = "close_with_error",
  LOAD = "load",
  SET_HEADER_PHONE = "set_header_phone",
  REACH_GOAL = "reach_goal",
  SEND_ANALYTICS = "send_analytics",
  SET_ANALYTICS_PARAMS = "set_analytics_params",
  OPEN = "open",
  CLOSE = "close",
  CLICK_CROSS = "click_cross",
  REACH_QUESTION = "reach_question",
  REACH_PHONE_FORM = "reach_phone_form",
  START = "start",
  START_BY_FLYING_BUTTON = "start_by_flying_btn",
  START_BY_SCROLL = "start_by_scroll",
  CLICK_TRADEMARK = "click_trademark",
  CLICK_HEADER_PHONE = "click_header_phone",
  CLICK_WHATSAPP_BUTTON = "click_whatsapp_button",
  CLICK_MINOR_BUTTON = "click_minor_button",
  SHOW_FLYING_BTN = "show_flying_btn",
  CHOOSE_DISTRIBUTOR_ANSWER = "choose_distributor_answer",
  GET_LEAD = "get_lead",
  GET_APPOINTMENT = "get_appointment", //Выбрали удобное время для приема
  CLICK_FINAL_PAGE_BUTTON = "click_final_page_button", //по-умолчанию "узнать о нас больше"
  SET_PARAMS = "set_params",
  SET_AB_TEST = "set_ab_test",
  SEND_LEAD_EXTRA_PARAMS = "set_lead_extra_params",
  SEND_EXTRA_PARAMS = "set_extra_params",
  ENABLE_WEBVISOR = "enable_webvisor",
  GET_QUIZ = "get_quiz",
  GET_INITIAL_DATA = "get_initial_data",
  UPDATE_LEAD = "update_lead",
  CHANGE_HISTORY = "change_history"
}